import { arrayMax } from "@omnia/shared/utils/array"
import { sum } from "../omnia"
import { INutritionPlan, INutritionService, NvzPlanCropping } from "../types"
import { sortApplicationDates } from "../utils"
import { INVZMessages } from "./types"

export function checkNMax(svc: INutritionService, model: INutritionPlan, crops: NvzPlanCropping[]) {

    const calcSvc = svc.calculationService

    return check()

    ///

    function check(): INVZMessages {

        var messages: INVZMessages = {
            error: false,
            canContinue: true,
            messages: []
        };

        let hasErrors = false;

        crops.filter(c => c.cropping.Field.NVZ).forEach(c => {

            var applications = model.Applications.filter(a => !!a.ApplicationDate)
                .sort((a1, a2) => sortApplicationDates(a1, a2));

            // Amount of N before the current plan
            let initAmount = getNitrogenAppliedPrevPlans(model, c.croppingId);

            let req = calcSvc.calculateClosingRequirements(c.planRequirements.crop, applications, c.cropping, false);

            var planAmount = Math.abs(req.RequiredN - c.planRequirements.crop.RequiredN);

            var nSupplied = initAmount + planAmount;

            var groups = svc.getNMaxCropGroups();
            var group = groups.find(g => g.Cropping.map(c => c.CroppingId).indexOf(c.croppingId) !== -1);

            if (group && group.NMaxAverage < nSupplied) {
                messages.messages.push({
                    info: true,
                    croppingId: c.cropping.CroppingId,
                    description: "Note: the total amount of nitrogen applied to this crop (" + Math.round(nSupplied) + " kg/ha) is higher than the average N max allowed (" + Math.round(group.NMaxAverage) + " kg/ha) for its crop group.",
                    application: applications.find(a => a.ApplicationDate === arrayMax(applications, a => a.ApplicationDate))
                });
            }

        });

        messages.error = hasErrors;

        return messages;

    }

    function getNitrogenAppliedPrevPlans(plan: INutritionPlan, croppingId: number): number {

        let applications = svc.getApplications().filter(a =>
            (a.CroppingId == croppingId)
            && (!a.Zone)
            && (a.PlanId != plan.NutritionPlanId)
        );

        return sum(applications, a => a.N);

    }

}
